/**
 * @file 页面入口
 */

import Vue from 'vue';
import App from './App.vue';
import 'element-ui/lib/theme-chalk/index.css';
import 'babel-polyfill';
import Elementui from 'element-ui';
import echarts from '@/plugin/echarts';
import request from '@/common/request';

import vueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

Vue.use(vueQuillEditor);
import '@/common/global.styl'

// import 'font-awesome/css/font-awesome.css';
import {clearObject, setObject} from '@/common/util';
import {Base64} from '@/common/base64';

import router from './router';
import store from './vuex/store';

Vue.use(Elementui, {size: 'mini'});
Vue.config.productionTip = false;

Vue.prototype.$http = request;
Vue.prototype.$echarts = echarts;
Vue.prototype.$Base64 = Base64;

Vue.prototype.$loading = function(val) {
    store.commit('CHANGE_LOADING_STATUS', val)
};
Vue.prototype.$clearObject = clearObject;
Vue.prototype.$setObject = setObject;


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
